import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import qs from 'qs';

// ファイルAPIベースURI
const resource = '/files';

/**
 * ファイル関連API呼出しクラス
 */
export default class FileRepository {

    constructor(private repository: AxiosInstance) { }

    /**
     * 構成データアップロード
     * @param file - ファイル
     * @return ファイル名
     */
    public async fileUpload(file: HTMLFormElement): Promise<string> {
        const headers = { "Content-type": "multipart/form-data" };

        const data = new FormData();
        data.append("selectFile", file.files.item(0));

        // API呼出し
        const response = await this.repository.post<string>(`${resource}`, data, { headers: headers });
        const fimeName = response.data
        if (fimeName == "") {
            // レスポンスが空の場合エラー
            throw new Error("response is nothing");
        }
        return fimeName;

    }

    /**
     * 構成データダウンロード
     * @param file - 添付ファイルID
     * @return ファイル
     */
    public async fileDownload(attachmentId: number): Promise<File> {

        const headers = { "Content-type": "application/octet-stream" };

        // API呼出し
        const response = await this.repository.get<File>(`${resource}/${attachmentId}`, { headers: headers, responseType: 'blob' });
        return response.data;

    }
}